import HttpClientToken from '../../services/HttpClientToken';
import HttpClientFileToken from '../../services/HttpClientFileToken';

import { AxiosError } from 'axios';

import { defaultHttpResponse, HttpResponse } from '../../interfaces/auth/AuthInterface';

import { BuscarLibroSentenciaDefinitivaParams, BuscarLibroSentenciaDefinitivaResponse, defaultBuscarLibroSentenciaDefinitivaResponse, DescargarInformacionParams, GuardarObservaciones } from '../../interfaces/libros-electronicos/LibroSentenciaDefinitivaInterface';

export const ObtenerLibroSentenciaDefinitiva = ( params: BuscarLibroSentenciaDefinitivaParams ) => {

    return new Promise<BuscarLibroSentenciaDefinitivaResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if ( data ) {

            const { token } = data;

            HttpClientToken.post('/Api/LibroSentenciaDefinitiva/ObtenerLibroSentenciaDefinitiva', params, token)
            .then(({ data }: { data: BuscarLibroSentenciaDefinitivaResponse }) => {
                resolve(data);
            })
            .catch( () => {
                resolve({ ...defaultBuscarLibroSentenciaDefinitivaResponse });
            });

        }

    });

}

export const GuardarObservacionesLibroSentenciaDefinitiva = ( params: GuardarObservaciones ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/LibroSentenciaDefinitiva/GuardarObservaciones', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const DescargarLibroSentenciaDefinitiva = ( params: DescargarInformacionParams ) => {

    return new Promise<Blob | null>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientFileToken.post('/Api/LibroSentenciaDefinitiva/DescargarInformacion', params, token)
            .then( ({ data } : { data : Blob } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( null );
            });

        }

    });

}
